import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import InsightsIcon from "@mui/icons-material/Insights";
import { Route } from "@mui/icons-material";

const MenuButtons = ({ buttonSelected, onButtonClick }) => {
  const listButtons = [
    {
      title: "Dibujar Ruta",
      icon: <BorderColorIcon style={{ color: "black" }} />,
      action: "draw",
      direction: "hidden",
    },
    {
      title: "Punto A a B",
      icon: <Route style={{ color: "black" }} />,
      action: "selectedPoints",
      direction: "right",
    },
    {
      title: "Generar Ruta",
      icon: <InsightsIcon style={{ color: "black" }} />,
      action: "generateRoute",
      direction: "left",
    },
  ];

  return (
    <Box>
      {listButtons.map((button, index) => (
        <Tooltip title={button.title} key={index}>
          <IconButton
            style={{
              backgroundColor: "#e7ef7d",
              borderRadius: 50,
              boxShadow:
                button.action === buttonSelected
                  ? "0px 1px 15px 2px rgba(0,0,0,1)"
                  : "0px 1px 15px 2px rgba(0,0,0,0.5)",
              margin: "0px 10px ",
              transform: button.action === buttonSelected ? "scale(1.1)" : "",
            }}
            onClick={() => onButtonClick(button.action, button.direction)}
            size={button.action === buttonSelected ? "medium" : "small"}
          >
            {button.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default MenuButtons;
